import React from 'react';

import { Box, Grid, Typography } from '@material-ui/core';

import SubHeader from '../../../components/Header/SubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import VehicleList from '../../../components/VehicleList/VehicleList.component';
import { useVehiclesContext } from '../../../context/vehicles/vehicles.provider';

const CirculationCardsList = () => {
  const { loading } = useVehiclesContext();

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action="Cargando vehiculos" />
      </Box>
      <SubHeader
        content={
          <Typography variant="h6" color="primary">
            Accedé a las tarjetas de tus vehículos
          </Typography>
        }
      />
      <Grid container justify="center" alignItems="center">
        <Grid item xs={11}>
          <VehicleList baseUrl="/circulation-card/" />
        </Grid>
      </Grid>
    </>
  );
};

export default CirculationCardsList;
